import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {LibOptionValue} from "daisy-design-system-front";
import {FormControl} from "@angular/forms";
import { DropdownComponent } from "../../dropdown/dropdown.component";
import { CalculationFunctionType } from 'swagger-gen/web-secured/models/calculation-function-type';

@Component({
    selector: 'app-select-analogic-calculation-function-type',
    standalone: true,
    imports: [CommonModule, DropdownComponent, TranslateModule],
    templateUrl: './select-analogic-calculation-function-type.component.html',
    styleUrls: ['./select-analogic-calculation-function-type.component.scss']
})
export class SelectAnalogicCalculationFunctionTypeComponent implements OnInit {
    @Input() valueFormControl = new FormControl<CalculationFunctionType | null>(null);

    public options : LibOptionValue<CalculationFunctionType>[] = [];

    constructor(private readonly translate : TranslateService) {
    }

    ngOnInit() : void {
      this.initOptions();
    }

    private initOptions() {
        this.options = Object.values(CalculationFunctionType).map(item => {
            return {
                label: this.translate.instant(`calculation.${item}`),
                value: item
            }
        });
    }
}
